import React, { useState, useEffect } from 'react';
import { FiCode, FiCheckCircle, FiZap, FiShield, FiShare2, FiStar ,FiCalendar, FiMapPin, FiFileText, FiImage, FiTool, FiLayout, FiSettings  } from 'react-icons/fi';
import axios from 'axios';

const iconMap = {
  'code': FiCode,
  'check-circle': FiCheckCircle,
  'lightbulb': FiZap,
  'robot': FiShield,
  'share-2': FiShare2,
  'calendar': FiCalendar,
  'map-pin': FiMapPin,
  'file-text': FiFileText,
  'image': FiImage,
  'tool': FiTool,
  'layout': FiLayout,
  'settings': FiSettings
};

function Servicos() {
  const [servicos, setServicos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServicos();
  }, []);

  const fetchServicos = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/servicos`);
 const servicosFormatados = response.data
        .map(s => ({
          ...s,
          destaque: s.destaque === 1 || s.destaque === true // Converte 0/1 para false/true
        }))
        .sort((a, b) => {
          // Destaques primeiro
          if (a.destaque && !b.destaque) return -1;
          if (!a.destaque && b.destaque) return 1;
          // Depois por ordem
          return (a.ordem || 0) - (b.ordem || 0);
        });
      
      setServicos(servicosFormatados);
    } catch (error) {
      console.error('Erro ao carregar serviços:', error);
      setServicos([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <section id="servicos" className="servicos">
      <div className="section-title">
        <h2>Nossos Serviços</h2>
        <p>Soluções completas para seu negócio digital</p>
      </div>
      
 <div className="servicos-grid">
  {servicos.map((servico) => {
    const IconComponent = iconMap[servico.icone] || FiCode;
    return (
      <div 
        key={servico.id} 
        className={`servico-card ${servico.destaque ? 'destaque' : ''}`}
      >
        {servico.destaque && (
          <div className="destaque-badge">
            <FiStar /> 
            <span className="destaque-texto">Destaque</span>
          </div>
        )}
        
        <div className="servico-header">
          <div className="servico-icon">
            <IconComponent />
          </div>
          <h3>{servico.titulo}</h3>
        </div>
        
        <p>{servico.descricao}</p>
      </div>
    );
  })}
</div>


    </section>
  );
}

export default Servicos;